import { Default, Detail,  List, Create } from "./views";

const Module = {
	name: "audiencerpolead",
	defaultRoutePath: "/audiences/audiencerpolead",
	menuItemScope: "audience",
	menuItemName: "audienceRpoLeads",

    routes: [
        {
            path: "/audiences/audiencerpolead",
            protected: true,
            children: [
                {
                    index: true,
                    path: "",
                    Component: Default,
                },
                {
                    path: "list",
                    Component: List,
                },
            ],
        },
    ],
    drawerRoutes: [
        {
            path: "list",
            Component: List,
        },
        {
            path: "detail",
            Component: Detail,
        },
        
        {
            path: "create",
            Component: Create,
        },
    ],

}

export default Module;
